import { render, staticRenderFns } from "./it-IT.vue?vue&type=template&id=43577e7c&"
import script from "./it-IT.vue?vue&type=script&lang=js&"
export * from "./it-IT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43577e7c')) {
      api.createRecord('43577e7c', component.options)
    } else {
      api.reload('43577e7c', component.options)
    }
    module.hot.accept("./it-IT.vue?vue&type=template&id=43577e7c&", function () {
      api.rerender('43577e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/it-IT.vue"
export default component.exports